var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-switch',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.checkStatus),callback:function ($$v) {_vm.checkStatus=$$v},expression:"checkStatus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }